import Loading from '@cartwhl/ui/atoms/Loading';
import Text from '@cartwhl/ui/base/Text';

import { ProgressInfo } from 'hooks/useFfmpeg';

export default function LoadingOverlay({
  progress,
}: {
  progress: ProgressInfo | null;
}) {
  if (!progress) return null;

  return (
    <>
      <div className="overlayShow bg-gray-90/50 absolute inset-0 top-0 right-0 bottom-0 left-0 z-10 rounded-lg" />
      <div className="dark:bg-gray-90 shadow-menu absolute top-1/2 left-1/2 z-10 flex max-h-[85vh] w-full max-w-[268px] -translate-x-1/2 -translate-y-1/2 flex-col items-center rounded-lg bg-white px-5 pt-6 pb-8 focus:outline-none">
        <Loading
          className="text-green h-10 w-10"
          trackClassName="stroke-gray-30"
        />
        <Text variant="studio/body/sm" className="mt-4">
          {progress
            ? `${progress.message} ${Math.round(progress.percentage)}%`
            : ''}
        </Text>
      </div>
    </>
  );
}
